/* @flow weak */
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';

import File from 'entities/File';
import FlexibleBlock from 'components/FlexibleBlock.jsx';
import Glyph from 'components/Glyph.jsx';
import Image from 'components/Image.jsx';
import Link from 'components/Link.jsx';
import List from 'components/List.jsx';
import Modal from 'components/Modal.jsx';
import Text from 'components/Text.jsx';

import './styles/ImageFilePreviewModal.scss';

class ImageFilePreviewModal extends React.Component {
  static propTypes = {
    file: React.PropTypes.instanceOf(File).isRequired,
  };

  handleCloseButtonClick = () => {
    this.props.onRequestHide();
  };

  handleModalClick = (event) => {
    const target = event.target;

    const header = ReactDOM.findDOMNode(this.refs.header);
    if (header.contains(target)) {
      return;
    }

    const image = ReactDOM.findDOMNode(this.refs.image);
    if (image.contains(target)) {
      return;
    }

    this.props.onRequestHide();
  };

  renderBody = () => {
    const { file } = this.props;
    const urls = file.getUrls();

    return (
      <div className="ImageFilePreviewModal-wrap">
        <div className="ImageFilePreviewModal-content">
          <Image
            ref="image"
            className="ImageFilePreviewModal-image"
            src={urls.large || urls.raw}
          />
        </div>
      </div>
    );
  };

  renderHeader = () => {
    const { file } = this.props;
    const urls = file.getUrls();

    return (
      <header ref="header" className="ImageFilePreviewModal-header">
        <FlexibleBlock className="ImageFilePreviewModal-actions" flex="left">
          <div className="ImageFilePreviewModal-fileInfo">
            <Text truncate>
              <Glyph name="image" size="medium" />
              {' '}
              {file.getName()}
            </Text>
          </div>
          <List horizontal>
            <li>
              <Link href={urls.raw} target="_blank">
                <Glyph name="fullscreen" size="small" />
                View original
              </Link>
            </li>
            <li>
              <Link href={urls.download} download>
                <Glyph name="download" size="small" />
                Download
              </Link>
            </li>
            <li>
              <Link onClick={this.handleCloseButtonClick}>
                <Glyph name="close" solo />
              </Link>
            </li>
          </List>
        </FlexibleBlock>
      </header>
    );
  };

  render() {
    const header = this.renderHeader();
    const body = this.renderBody();

    return (
      <Modal
        {...this.props}
        className={cx('ImageFilePreviewModal', this.props.className)}
        theme="dark"
        onClick={this.handleModalClick}>
        {header}
        {body}
      </Modal>
    );
  }
}

export default ImageFilePreviewModal;



// WEBPACK FOOTER //
// ./src/components/ImageFilePreviewModal.jsx